import Collection from "../../../data-structures/collection"
import ActionEntity, {ActionScope} from "./action-entity"
import Task from "../../task/task"

// the task's project the automation scope resolves to - one of the task's own projects (its main
// one or any it is linked into) when it matches the scope project directly, or the task's project
// nested under the scope project when the automation has applyToSubfolders.
// null means the scope project doesn't cover this task at all;
// for a global scope (no scope project) it's just the task's main project
function getScopeMatchedProjectId(task:Task, scope:ActionScope): ID | null {
    const scopeProjectId = scope.projectId

    if (!scopeProjectId) {
        return task.projectId
    }

    if (task.isInProject(scopeProjectId)) {
        return scopeProjectId
    }

    if (!scope.applyToSubfolders) {
        return null
    }

    return _.find(task.projectsIds, (projectId: ID) => {
        return gd.session.projects.getAllParentsIds(projectId).includes(scopeProjectId)
    }) ?? null
}

export default class ActionEntitiesCollection extends Collection<ActionEntity> {

    constructor(models: ActionEntity[]) {
        super(models)
    }

    // automations applicable to a task - the task must be in the automation's scope project, or
    // (when scope.applyToSubfolders is set) in a subfolder of it;
    // scope.projectAccess is a minimum access required in the matched project, omitted means unrestricted;
    // scope.taskTypeIds restricts the automation to tasks of the listed types, omitted means unrestricted
    filterForTask(task:Task): ActionEntity[] {
        return _.filter(this.models, (automation: ActionEntity) => {
            const matchedProjectId = getScopeMatchedProjectId(task, automation.scope)

            if (!!automation.scope.projectId && !matchedProjectId) {
                return false
            }

            if (
                !_.isEmpty(automation.scope.taskTypeIds)
                && !automation.scope.taskTypeIds!.includes(task.taskTypeId)
            ) {
                return false
            }

            if (automation.scope.projectAccess == null) {
                return true
            }

            // access is taken in the task's own project, not in the scope one - with
            // applyToSubfolders the scope project may not even be in the user's session
            const access = matchedProjectId
                ? gd.session.projects.get(matchedProjectId)?.access
                : undefined

            return (access ?? -Infinity) >= automation.scope.projectAccess
        })
    }
}
